import EditIcon from './Icons/components/EditIcon';
import ViewIcon from './Icons/components/ViewIcon';
import RotateCcwIcon from './Icons/components/RotateCcw';
import CloseIcon from './Icons/components/CloseIcon';
import ArrowDownIcon from './Icons/components/ArrowDownIcon';
import NextIcon from './Icons/components/NextIcon';
import PreviousIcon from './Icons/components/PreviousIcon';
import DocumentIcon from './Icons/components/DocumentIcon';
import TrashIcon from './Icons/components/TrashIcon';
import PlusIcon from './Icons/components/PlusIcon';
import SuccessIcon from './Icons/components/SuccessIcon';
import ErrorIcon from './Icons/components/ErrorIcon';
import AddSectionIcon from './Icons/components/AddSectionIcon';
import ToggleArrowIcon from './Icons/components/ToggleArrowIcon';
import FileIcon from './Icons/components/file-upload/FileIcon';
import FileUploadIcon from './Icons/components/file-upload/FileUploadIcon';
import InfoIcon from './Icons/components/InfoIcon';
import PlusIcons from './Icons/components/PlusIcons';
import MinusIcon from './Icons/components/MinusIcon';
import CheckIcon from './Icons/components/CheckIcon';
import BorderSquareIcon from './Icons/components/BorderSquareIcon';
import MinusBoxIcon from './Icons/components/MinusBoxIcon';

import PdfIcon from './Icons/components/PdfIcon';
import SignUploadIcon from './Icons/components/SignUploadIcon';
import SignatureIcon from './Icons/components/SignatureIcon';
import EyeIcon from './Icons/components/ViewIcon';
import EyeOffIcon from './Icons/components/EyeOffIcon';
import LightningIcon from './Icons/components/LightningIcon';
import SwitchIcon from './Icons/components/SwitchIcon';
import CommentIcon from './Icons/components/CommentIcon';
import TickDaisy from './Icons/components/TickDaisy';
import ClockIcon from './Icons/components/ClockIcon';
export default {
  editIcon: EditIcon,
  viewIcon: ViewIcon,
  rotateCcwIcon: RotateCcwIcon,
  closeIcon: CloseIcon,
  arrowDownIcon: ArrowDownIcon,
  nextIcon: NextIcon,
  previousIcon: PreviousIcon,
  documentIcon: DocumentIcon,
  trashIcon: TrashIcon,
  plusIcon: PlusIcon,
  errorIcon: ErrorIcon,
  successIcon: SuccessIcon,
  addSectionIcon: AddSectionIcon,
  toggleArrowIcon: ToggleArrowIcon,
  fileIcon: FileIcon,
  fileUploadIcon: FileUploadIcon,
  infoIcon: InfoIcon,
  plusIcons: PlusIcons,
  minusIcon: MinusIcon,
  checkIcon: CheckIcon,
  borderSquareIcon: BorderSquareIcon,
  minusBoxIcon: MinusBoxIcon,
  pdfIcon: PdfIcon,
  signUploadIcon: SignUploadIcon,
  signatureIcon: SignatureIcon,
  eyeIcon: EyeIcon,
  eyeOffIcon: EyeOffIcon,
  lightningIcon: LightningIcon,
  switchIcon: SwitchIcon,
  commentIcon: CommentIcon,
  tickDaisy: TickDaisy,
  clockIcon: ClockIcon,
};
